import React, { useState } from 'react';
import { DatePicker, Button, Space, Row } from 'antd';
import { Spacing } from 'works/legacy/lib/style-helper';
import { Moment } from 'moment';

const { RangePicker } = DatePicker;
const dateFormat = 'MM/DD/YYYY';

// Type that satisfies the current type constraints
// it would be better if it were just a list of DatetimeType (see @TODO below)
type ChangeValue = (Moment | string | null)[] | null;

export const DateRangeFilter = ({
  onChange,
  onSearch,
  defaultValue = [],
  autoFocus,
}: {
  onChange?: (search: ChangeValue) => void;
  onSearch?: (search: ChangeValue) => void;
  // @TODO(WORK-5920): migrate this filter to dayjs — accept/emit `DatetimeType`
  // from @common/services/datetime and bridge to moment internally for the antd v4
  // RangePicker, so consumers stop converting via dayjsToMoment/momentToDayjs.
  defaultValue?: Moment[];
  autoFocus: boolean;
}) => {
  const [queryString, setQueryString] = useState<ChangeValue>(defaultValue);

  return (
    <>
      <Space
        style={{
          display: 'flex',
          marginBottom: Spacing.baseSpacing / 2,
        }}
      >
        <RangePicker
          autoFocus={autoFocus}
          defaultValue={[defaultValue[0], defaultValue[1]]}
          onChange={(value) => {
            setQueryString(value);
            onChange?.(value);
          }}
          format={dateFormat}
          placeholder={['From date', 'To date']}
        />
      </Space>
      <Row justify="end">
        <Button
          type="primary"
          onClick={() => {
            onSearch?.(queryString);
            setQueryString(null);
          }}
          size="small"
          style={{ width: 90 }}
        >
          Apply
        </Button>
      </Row>
    </>
  );
};
